/* content.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./content.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { fg } from '@atlaskit/platform-feature-flags';
// To be removed with platform-component-visual-refresh (BLU-2992)
var baseStylesOld = null;
var baseStyles = null;

// To be removed with platform-component-visual-refresh (BLU-2992)
var linkStylesOld = null;
var linkStyles = null;
var hasAfterStylesOld = null;
var hasAfterStyles = null;

// To be removed with platform-component-visual-refresh (BLU-2992)
var hasBeforeStyles = null;
var Content = function Content(_ref) {
  var _ref$elemBefore = _ref.elemBefore,
    elemBefore = _ref$elemBefore === void 0 ? null : _ref$elemBefore,
    _ref$isRemovable = _ref.isRemovable,
    isRemovable = _ref$isRemovable === void 0 ? true : _ref$isRemovable,
    _ref$text = _ref.text,
    text = _ref$text === void 0 ? '' : _ref$text,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'standard' : _ref$color,
    href = _ref.href,
    linkComponent = _ref.linkComponent;
  var Link = linkComponent !== null && linkComponent !== void 0 ? linkComponent : 'a';
  if (href) {
    return /*#__PURE__*/React.createElement(Link, {
      href: href,
      "data-color": color,
      className: ax([fg('platform-component-visual-refresh') ? "_11c82smr _1reo15vq _18m915vq _p12fmgvx _1bto1l2s _o5721q9c" : "_11c82smr _1reo15vq _18m915vq _p12fmgvx _y4ti1b66 _bozg1b66 _1bto1l2s _o5721q9c", fg('platform-component-visual-refresh') ? "_4bfu1r31 _1hmsglyw _ajmmnqa1 _syaz1fxt _lcxv1wug _nt751r31 _49pcglyw _1hvw1o36 _9oik1r31 _1bnx8stv _jf4cnqa1 _30l31fxt _1nrm1r31 _c2wa8stv _1iohnqa1 _9h8h1fxt" : "_4bfu1r31 _1hmsglyw _ajmmnqa1 _syazs5nr _lcxv1wug _nt751r31 _49pcglyw _1hvw1o36 _9oik1r31 _1bnx8stv _jf4cnqa1 _30l3117u _1nrm1r31 _c2wa8stv _1iohnqa1 _9h8h1348", !fg('platform-component-visual-refresh') && elemBefore && "_ahbqv47k", isRemovable && fg('platform-component-visual-refresh') && "_p12f1lit", isRemovable && !fg('platform-component-visual-refresh') && "_p12f1lit _y4tipxbi"])
    }, text);
  } else {
    return /*#__PURE__*/React.createElement("span", {
      className: ax([fg('platform-component-visual-refresh') ? "_11c82smr _1reo15vq _18m915vq _p12fmgvx _1bto1l2s _o5721q9c" : "_11c82smr _1reo15vq _18m915vq _p12fmgvx _y4ti1b66 _bozg1b66 _1bto1l2s _o5721q9c", !fg('platform-component-visual-refresh') && elemBefore && "_ahbqv47k", isRemovable && fg('platform-component-visual-refresh') && "_p12f1lit", isRemovable && !fg('platform-component-visual-refresh') && "_p12f1lit _y4tipxbi"])
    }, text);
  }
};

// eslint-disable-next-line @repo/internal/react/require-jsdoc
export default Content;